import { LitElement, html, css} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import '../../voyage-popup/src/voyage-popup';
import '../../voy-timeinput/src/voy-timeinput';
import { Prediction } from '../../../src/services/tides-service';
import { TimeZone } from './voy-tide-info-popup';

@customElement('voy-tide-heights-table')
export class VoyTideHeightsTable extends LitElement
{
    @property({type: Object}) data: Prediction[] = [];
    @property({type: Object}) timeZone: TimeZone = { label: "UTC 0", offset: 0 };
    @property({attribute: false}) private _timeHeaders: string[] = [];
    @property({attribute: false}) private _dataStructure: Map<string, Map<string, number>> = new Map<string, Map<string, number>>();

    static get styles()
    {
        return [
            css`
            :host {
            }

            table {
                border-collapse: collapse;
                text-align: center;
                font-family: MaerskText;
                font-size: 12px;
                width: 100%;
            }

            table, th, td {
                border: 1px solid var(--neutrals-grey-07);
            }

            .container {
            }

            .dateHeader {
                width: 63px;
                min-width: 63px;
                max-width: 63px;
                height: 30px;
                min-height: 30px;
                max-height: 30px;
                background: var(--neutrals-grey-09);
                color: var(--neutrals-grey-04);
                white-space: nowrap;
                position: sticky;
                z-index: 1;
                left: 0;
            }

            .datacell {
                width: 43px;
                min-width: 43px;
                height: 30px;
                min-height: 30px;
                max-height: 30px;
                color: var(--neutrals-grey-02);
                background: var(--neutrals-grey-10);
            }

            .timestampHeader {
                width: 43px;
                height: 30px;
                color: var(--neutrals-grey-04);
                background: var(--neutrals-grey-09);
                position: sticky;
                z-index: 2;
                top: 0;
            }

            .timestampHeader.corner {
                z-index: 3;
                left: 0;
                border: 1px solid var(--neutrals-grey-07);
                background: var(--neutrals-grey-10);
            }
        `
        ];
    }

    render()
    {
        return html`
        <div class="container">
            <table>
                <tr>
                    <td class="timestampHeader corner"></td>
                    ${this._timeHeaders.map(t => {
                        return html`
                            <td class="timestampHeader">${t}</td>
                        `;        
                    })}
                </tr>
                ${Array.from(this._dataStructure.keys()).map(dateHeader => this.renderRow(dateHeader))}
            </table>
        </div>
        
        `;
    }

    renderRow(dateHeader: string): any {
        return html`
            <tr class="row">
                <td class="dateHeader">${dateHeader}</td>
                ${this._timeHeaders.map(t => {
                        if (this._dataStructure.get(dateHeader)!.has(t)) {
                            return html`
                                <td class="datacell">${this._dataStructure.get(dateHeader)!.get(t)!.toFixed(1)}</td>
                            `;
                        } else {
                            return html`
                                <td class="datacell empty"></td>
                            `;
                        }
                    })
                }
            </tr>
        `;
    }

    updated(changedProperties: Map<string | number | symbol, unknown>) {
        if (changedProperties.has("data")) {
            this._createDataStructure();
        }
    }

    private _createDataStructure() {
        const timeHeaders = new Set<string>();
        this._dataStructure = new Map<string, Map<string, number>>();

        for (let i=0; i< this.data.length; i++) {
            const date = new Date(Date.parse(this.data[i].DateTime) + this.timeZone.offset);
            const height = this.data[i].Height;
            const timeheader = `${date.getUTCHours()}:${date.getUTCMinutes().toString().padStart(2,"0")}`;
            const dateheader = `${date.getUTCDate()}/${date.getUTCMonth() + 1}`;

            if (!this._dataStructure.has(dateheader)) {
                this._dataStructure.set(dateheader, new Map<string, number>());
            }

            this._dataStructure.get(dateheader)!.set(timeheader, height);
            timeHeaders.add(timeheader);
        }

        this._timeHeaders = Array.from(timeHeaders);
        this._timeHeaders.sort((a, b) => this._convertToDate(a) - this._convertToDate(b));
    }

    private _convertToDate(hhmm: string) : number{
        let date = new Date();
        let [hours, minutes] = hhmm.split(':'); 
    
        date.setHours(+parseInt(hours)); // set the hours, using implicit type coercion
        date.setMinutes(parseInt(minutes)); //you can pass Number or String, it doesn't really matter
        return date.getTime();
    }
};
